import type { Theme, ThemeStyle } from '@admin/shared/themes/default';

/**
 * Override styles for Typography.
 *
 * @param {Theme} theme - current theme
 *
 * @returns {ThemeStyle}
 */
export const getMuiTypographyStyle = (theme: Theme): ThemeStyle => {
  return {
    root: {},

    subtitle1: {
      fontSize: 16,
      fontWeight: 500,
    },

    subtitle2: {
      fontSize: 14,
      fontWeight: 'bold',

      lineHeight: 1,
      letterSpacing: '0.00938em',
    },

    body1: {
      fontSize: 14,
      lineHeight: 1.29,
    },

    body2: {
      fontSize: 10,
      lineHeight: 1.4,
    },

    caption: {},
    button: {},

    h1: {
      fontSize: 22,
      fontWeight: 'bold',
      lineHeight: 'normal',
      letterSpacing: 'normal',
    },

    h2: {
      fontSize: 18,
      fontWeight: 500,
    },

    h3: {
      fontSize: 14,
      fontWeight: 500,
    },
    h4: {},
    h5: {},
    h6: {},

    colorTextPrimary: {
      color: theme.palette.text.primary,
    },

    colorTextSecondary: {
      color: theme.palette.grey['300'],
    },
  };
};
